import YMBrownHeader from "./ym-hat-brn/IMG_1412.jpg";
import img1 from "./ym-hat-brn/IMG_1401.jpg";
import img2 from "./ym-hat-brn/IMG_1402.jpg";
import img3 from "./ym-hat-brn/IMG_1403.jpg";
import img4 from "./ym-hat-brn/IMG_1404.jpg";
import img5 from "./ym-hat-brn/IMG_1405.jpg";
import img6 from "./ym-hat-brn/IMG_1406.jpg";
import img7 from "./ym-hat-brn/IMG_1407.jpg";
import img8 from "./ym-hat-brn/IMG_1408.jpg";
import img9 from "./ym-hat-brn/IMG_1409.jpg";
import img10 from "./ym-hat-brn/IMG_1410.jpg";
import img11 from "./ym-hat-brn/IMG_1411.jpg";
import img13 from "./ym-hat-brn/IMG_1413.jpg";

export const BrownHatHeader = YMBrownHeader;

export const images = [
  img13,
  YMBrownHeader,
  img11,
  img10,
  img9,
  img8,
  img7,
  img6,
  img5,
  img4,
  img3,
  img2,
  img1,
];

const Products = [
  {
    image: YMBrownHeader,
    title: "Yung Hat (Brown)",
    price: 999,
    id: 1,
    description: "A brown hat with a Yung Men logo on the front.",
  },
  //   {
  //     title: "Yung Hat (Blue)",
  //     price: 999,
  //     id: 2,
  //     description: "A brown hat with a Yung Men logo on the front.",
  //   },
];

export default Products;
